module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/TemperatureRange-a36e46afd26ae9502d3c79ce26ba821a.png";